export const UrlServer = require('../server-address.json').http + '/api';
export const UrlWeb = require('../server-address.json').webUrl;
